import type { TranslationDictionary } from '../data/types';
import { generatedHotspotLabelsEn } from './generated/hotspot-labels';
import { generatedSceneLabelsEn } from './generated/scene-labels';

const en: TranslationDictionary = {
  ui: {
    ...generatedHotspotLabelsEn,
    'app.eyebrow': 'High-Tech Medical Zone',
    'app.title': '360° Virtual Tour',
    'app.subtitle': 'Explore City International Hospital & Gia An 115 Hospital from every angle.',
    'app.startTour': 'Start tour',
    'app.suggestedJourneys': 'Suggested journeys',
    'app.sceneList': 'Scene list',
    'app.booking': 'Book appointment',
    'app.hotline': 'Call hotline',
    'app.backToWebsite': 'Back to main website',
    'app.fullscreen': 'Fullscreen',
    'app.exitFullscreen': 'Exit fullscreen',
    'app.gyro': 'Gyroscope',
    'app.loading': 'Loading panorama…',
    'app.close': 'Close',
    'app.currentScene': 'Now viewing',
    'app.viewControls': 'View controls',
    'app.zoomIn': 'Zoom in',
    'app.zoomOut': 'Zoom out',
    'app.autorotateStart': 'Auto-rotate',
    'app.autorotateStop': 'Stop auto-rotate',
    'app.resetView': 'Reset to initial view',
    'app.autoTourStart': 'Auto tour',
    'app.autoTourStop': 'Stop auto tour',
    'app.lookUp': 'Look up',
    'app.lookDown': 'Look down',
    'app.lookLeft': 'Turn left',
    'app.lookRight': 'Turn right',
    'app.focusView': 'Focus view',
    'app.hideToolbar': 'Hide menu bar',
    'app.hideControls': 'Hide controls',
    'app.showControls': 'Show controls',
    'app.showUi': 'Show menu',
    'app.lang.vi': 'VI',
    'app.lang.en': 'EN',
  },
  groups: {
    'groups.overview': 'Overview/Flycam',
    'groups.cih': 'City International Hospital (CIH)',
    'groups.gia-an': 'Gia An 115 Hospital',
  },
  scenes: {
    ...generatedSceneLabelsEn,
  },
  journeys: {
    'journeys.investor.label': 'Investor / Partner',
    'journeys.investor.description':
      'Campus flycam → Welcome → CIH & Gia An lobbies → Emergency, imaging, OR, Lim Premier',
    'journeys.patient-cih.label': 'First-time patient — CIH',
    'journeys.patient-cih.description': 'Lobby → Reception → Waiting → Outpatient → Inpatient / VIP',
    'journeys.specialist-ga.label': 'Specialist visit — Gia An',
    'journeys.specialist-ga.description':
      'Lobby → Outpatient → Imaging → OR / Physiotherapy → Lim Premier → Showcase rooms',
  },
};

export default en;
